async function devtricker_followUser(event, button, followAction) {
    event.stopPropagation();

    try {
        button.disabled = true;

        let authorId = button.getAttribute('data-author-id');

        await devtricker_validateUserToFollowId(authorId);
        await devtricker_validateFollowAction(followAction);

        let loggedUserId = devtricker_getTheLoggedUserId();

        if (!loggedUserId) {
            button.disabled = false;
            devtricker_closeAllPopovers();
            devtricker_openSocialLoginModal();
            return;
        }

        await devtricker_updateFollowButtonOptimisticallyAndPersistInIndexedDb(button, authorId, followAction, loggedUserId);
        devtricker_post_ajaxFollowUser(authorId, followAction);

        button.disabled = false;

        await devtricker_process_refreshHovercardByUser(authorId, followAction);
        await devtricker_initializeOrUpdateFollowPostAuthorButton(authorId);

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR, "Error when try follow or unfollow a user.");
        button.disabled = false;
    }
}

async function devtricker_validateUserToFollowId(userToFollowId) {
    if (!userToFollowId) {
        throw new Error('userToFollowId validation - userToFollowId is required');
    }

    if (isNaN(userToFollowId) || parseInt(userToFollowId) <= 0) {
        throw new RangeError('userToFollowId validation - invalid userToFollowId argument: ' + userToFollowId);
    }
}

async function devtricker_validateFollowAction(followAction) {
    if (!typeof followAction === "boolean") {
        throw new RangeError('invalid followAction argument:' + followAction);
    }
}
